import * as React from 'react';

import {DeployFailure, Icon} from '../util';

interface Props {
	deployResponse: ConfigTester.DeployResponse | null;
	deployErrorMessage: string | null;
	deployStatus: ConfigTester.DeployStatus | null;
	onCollapse(): void;
}

function getTenantUrl(deployResponse: ConfigTester.DeployResponse) {
	return `https://${__FEV2_URL__}/logout?loginTenantHostname=${deployResponse.hostname}`;
}

export default class DeploymentStatus extends React.Component<Props, {}> {

	public render() {
		const {deployStatus} = this.props;
		switch (deployStatus) {
			case 'DEPLOYMENT_SUCCESS':
				return this.renderWithContainer(this.renderSuccess());
			case 'DEPLOYMENT_FAILURE':
				return this.renderWithContainer(this.renderFailure());
			default:
				return null;
		}
	}

	private renderWithContainer(child: React.ReactNode) {
		return <div className='row-expanded'>
			{this.renderCollapseDeployResultLink()}
			{child}
		</div>;
	}

	private renderSuccess() {
		const {deployResponse} = this.props;
		if (deployResponse && deployResponse.success) {
			return <div className='deploy-response-container'>
				<div className='deploy-response'>
					<h2 className='bolder'>Deploy Result</h2>
					<div className='deploy-response-message'>
						<Icon name='check-circle' className='deploy-success-icon fa-2x' />
						<h4>Configuration deployed successfully.</h4>
						<h4>
							<a href={getTenantUrl(deployResponse)} target='_blank'>
								Go to instance <Icon name='external-link' />
							</a>
						</h4>
					</div>
				</div>
			</div>;
		} else {
			return null;
		}
	}

	private renderFailure() {
		const {deployErrorMessage} = this.props;
		if (this.props.deployResponse || deployErrorMessage) {
			return <div className='deploy-response-container'>
				<div className='deploy-response'>
					<h2 className='bolder'>Deploy Result</h2>
					<div className='deploy-response-message'>
						<Icon name='times-circle' className='deploy-failure-icon fa-2x' />
						<h4>{deployErrorMessage || 'Failed to deploy configuration'}</h4>
					</div>
				</div>
				<div className='deploy-response'>
					<DeployFailure deployResponse={this.props.deployResponse} />
				</div>
			</div>;
		} else {
			return null;
		}
	}

	private renderCollapseDeployResultLink() {
		return <a onClick={this.props.onCollapse}>
			Hide Deploy Result <Icon name='eye-slash' />
		</a>;
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-tester/DeploymentStatus.tsx